import React from "react";
import logo from "../pictures/logo.png";
import {
  AiFillFacebook,
  AiFillInstagram,
  AiFillLinkedin,
  AiFillTwitterCircle,
  AiFillYoutube,
} from "react-icons/ai";
import {RiArrowRightDoubleLine} from "react-icons/ri";
import {TiLocation} from "react-icons/ti";
import {AiOutlineMail,AiOutlineMobile} from "react-icons/ai";


const Footer = () => {
  return (
    <>
      <footer>
        <div className="footer_container">
          <div className="footer_piller">
            <img src={logo} />
            <p>
              Our main focus is to accelerate profitable brand development for
              our clients and to re-invent market research through our services.
              We cater to a varied client-base, ranging from government bodies
              and NGOs to corporates and start-ups.
            </p>
            <hr/>
            <h2>Social Media</h2>
            <div className="footer_socialmedia">
            <span className="icons facebook">
            <a
              href="https://www.facebook.com/TimeCyberMedia/"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillFacebook />
            </a>
          </span>
          <span className="icons twitter">
            <a
              href="https://twitter.com/i/flow/login?redirect_after_login=%2Ftimecybermedia"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <AiFillTwitterCircle />{" "}
            </a>
          </span>
          <span className="icons youtube">
            <a
              href="https://www.youtube.com/@timecybermedia7561"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillYoutube />
            </a>
          </span>
          <span className="icons linkedin">
            <a
              href="https://www.linkedin.com/company/time-cyber-media-pvt.-ltd"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <AiFillLinkedin />
            </a>
          </span>
          <span className="icons instagram">
            <a
              href="https://www.instagram.com/timecybermedia/?igshid=YmMyMTA2M2Y%3D"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillInstagram />
            </a>
          </span>
            </div>
          </div>

          <div className="footer_piller">
            <div className="footer_info">
            <h2>Contact Info</h2>
              <p>
              <TiLocation color="yellow"/> C-31, 3rd Floor,Nawada Housing Complex Complex,Opp.<br/>
              Piller No 792,Shivaji Marg,New Delhi 110059
             </p> 
             <p><AiOutlineMail color="yellow"/>&nbsp;
              info@timescybermedia.com
             </p>
             <p><AiOutlineMobile color="yellow"/>&nbsp;
              +91-9821020995, +91-9873004416
             </p>
            </div>
            <div className="footer_info">
              <h2>Website link</h2>
              <a><RiArrowRightDoubleLine size={20}/> Timescybermedia</a>
              <a><RiArrowRightDoubleLine size={20}/>Indiabrandicon</a>
              <a><RiArrowRightDoubleLine size={20}/>International Healthcare</a>
              <a><RiArrowRightDoubleLine size={20}/>Indian icon of the year</a>
              <a><RiArrowRightDoubleLine size={20}/>International Education Award</a>
              <a><RiArrowRightDoubleLine size={20}/>International leadership Award</a>
            </div>
          </div>
        </div>
      </footer>
      {/* <footer className="copyright_footer">
        <h2 className="copyright">&#169;Copyright Ashu Lohra</h2>
      </footer> */}
    </>
  );
};

export default Footer;
